import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
    providedIn: 'root'
})

export class AuthGuard {
    private publicRoutes: string[] = ['/industries/onlineevents'];
    constructor(private httpClient: HttpClient, private router: Router, private authenticationService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (this.publicRoutes.includes(state.url) || currentUser) {
            return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    public isFormActive(): boolean {
        const status = history.state;
        if (status === undefined || status === null) {
            return false;
        } else {
            return true;
        }
    }

    public isFormSubmitted(data: object, requestName: string) {
        this.formSubmission(data).subscribe(res => {
            if (res) {
                this.router.navigate(['thank-you'], { state: { data: requestName } });
            } else {
                this.router.navigate(['404']);
            }
        });
    }

    private formSubmission(emailRequest): Observable<any> {
        return this.httpClient.post(environment.emailEndPointAPI,
            emailRequest, { headers: { authToken: environment.emailAuthToken } }).pipe(res => {
                return res;
            });
    }

}
